/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */

export const initDashboard = ({ bar={labels: [], data: []}, height = 200, chartType = "bar", percent=0 }) => {

	try {
		var e = bb.generate({
			data: {
				columns: [["data", 65]],
				type: "gauge",
				onclick: function (e, o) {
					console.log("onclick", e, o);
				},
				onover: function (e, o) {
					console.log("onover", e, o);
				},
				onout: function (e, o) {
					console.log("onout", e, o);
				},
			},
			gauge: {
				label: {
					extents: function () {
						return "";
					},
				},
			},
			color: {
				pattern: [
					window?.themeColors?.primary,
					window?.themeColors?.secondary,
					window?.themeColors?.green,
					window?.themeColors?.purple,
				],
				threshold: { values: [30, 60, 90, 100] },
			},
			size: { height: 90, width: 90 },
			padding: { bottom: 0 },
			legend: { show: !1, position: "inset" },
			bindto: "#welcome-gauge",
		});
		setTimeout(function () {
			e.load({ columns: [["data", 10]] });
		}, 1e3),
			setTimeout(function () {
				e.load({ columns: [["data", percent]] });
			}, 2e3);
		var o = {
			series: [{ name: "Appointments", data: bar.data }],
			chart: { height: height, type: chartType, toolbar: { show: !1 } },
			colors: "#e6a20d",
			title: { text: "Appointments", align: "left" },
			legend: { position: "top" },
			dataLabels: { enabled: !1 },
			stroke: { width: 0, curve: "smooth", lineCap: "round" },
			plotOptions: {
				bar: {
					columnWidth: "15%",
					borderRadius: 3
				},
			},
			grid: {
				show: false
			},
			yaxis: {
				show: false
			},		
			xaxis: {
				type: "datetime",
				categories: bar.labels,
			},
			tooltip: { x: { format: "dd-MM-yyyy" } },
		};
		new ApexCharts(document.querySelector("#interviews-chart"), o).render();
		
	} catch (error) {
		console.log(error)
	}

}